import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import {
    withStyles,
    CircularProgress,
    LinearProgress,
    Divider,
    InputAdornment,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    Button,
    Tooltip
} from '@material-ui/core';
import { Visibility, VisibilityOff, Refresh } from '@material-ui/icons';
import { FHEButton, FHETextField, FHEReactSelect, OneWifiItem } from 'data/components';
import { WifiIcon } from 'data/common/iconsvg';
import { getHeatAndCoolWifiList, startHeatAndCoolInclusion } from '../../../../data/Products/actions';
import memoizeOne from 'memoize-one';

class wizardAddHeatAndCool extends PureComponent {
    static propTypes = {
        getHeatAndCoolWifiList: PropTypes.func.isRequired,
        startHeatAndCoolInclusion: PropTypes.func.isRequired,
        goBack: PropTypes.func.isRequired,
        resetProduct: PropTypes.func.isRequired,
        middlewareState: PropTypes.string.isRequired,
        fheCenterMac: PropTypes.string.isRequired,
        middleware: PropTypes.string.isRequired,
        theme: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.mounted = true;
        this.state = {
            step: 'loadingMiddleware',
            productAP: '',
            /* LISTS */
            wifiSelection: false,
            wifiList: [],
            wifiForm: {
                ssid: null,
                password: null,
                encryption: 'WPA2',
                encryption_type: 'TKIP'
            },

            /* HELPERS */
            showPassword: false,
            currentStepSlug: null,
            inclusionPrct: null,

            /* LOADERS */
            loading: true,
            loadingInclusion: false,

            /* ERRORS */
            error: null,
            inclusionError: null,
            errorWifi: null
        };
        this.delayToCheckMiddleWare = 500;
        this.maxCheckMiddleware = 10;
        this.delayToRefreshAP = 5000;
        this.encryptions = [
            { value: 'WPA2', label: Translator.translate('generic.products.addProduct.wifiForm.wpa2') },
            { value: 'WPA', label: Translator.translate('generic.products.addProduct.wifiForm.wpa') }
        ];
        this.encryptionTypes = [
            { value: 'AES', label: Translator.translate('generic.products.addProduct.wifiForm.aes') },
            { value: 'TKIP', label: Translator.translate('generic.products.addProduct.wifiForm.tkip') }
        ];
    }

    componentDidMount() {
        const { middlewareState } = this.props;

        if (middlewareState !== 'connected') {
            this.checkMiddlewareState();
        } else {
            this.getHeatAndCoolWifiList();
        }
    }

    /* HELPERS */
    addAnotherProduct = () => {
        this.setState({
            loading: true,
            error: null,
            wifiSelection: false,
            wifiList: [],
            showPassword: false,
            currentStepSlug: null,
            inclusionPrct: null,
            inclusionError: null
        });
        this.getHeatAndCoolWifiList();
    };

    formatNetworks = networks => {
        let wifiList = [];
        const regexpSignal = /([0-9]+)\/[0-9]+/g;
        networks.map(network => {
            if (Object.keys(network).length > 0) {
                const elemSignalRegexResult = network['Signal'].match(regexpSignal);
                const signal = elemSignalRegexResult ? elemSignalRegexResult[0] : '0/70';
                const signalObj = signal.split('/');
                const signalOver100 = parseInt((signalObj[0] * 100) / signalObj[1]);

                wifiList.push({
                    bssid: network['Address'],
                    signalLevel: signalOver100,
                    ssid: network['ESSID'],
                    encryption: network['Encryption'].indexOf('WPA2') !== -1 ? 'WPA2' : network['Encryption'].indexOf('WPA') !== -1 ? 'WPA' : '',
                    encryption_type: network['Encryption'].indexOf('TKIP') !== -1 ? 'TKIP' : network['Encryption'].indexOf('AES') !== -1 ? 'AES' : ''
                });
            }
        });

        return wifiList;
    };

    getBetterSignalLevelWifi = (list, property) => {
        let val,
            result = [],
            ssidArray = [];
        for (let i = 0; i < list.length; i++) {
            val = list[i][property];
            if (!ssidArray.includes(val)) {
                result.push(list[i]);
                ssidArray.push(list[i].ssid);
            }
        }
        return result;
    };
    handleChange = event => {
        const { wifiForm } = this.state;
        let targetValue = event.target.value;

        if (targetValue === '') targetValue = null;

        this.setState({
            wifiForm: { ...wifiForm, [event.target.name]: targetValue }
        });
    };
    handleClickShowPassword = () => {
        const { showPassword } = this.state;
        this.setState({
            showPassword: !showPassword
        });
    };
    showWifiList = () => {
        this.setState({
            wifiSelection: true
        });
    };
    hideWifiList = () => {
        this.setState({
            wifiSelection: false
        });
    };
    selectWifi = wifi => {
        this.setState({
            wifiForm: wifi,
            wifiSelection: false
        });
    };
    stepAction = args => {
        this.setState({
            currentStepSlug: args.step,
            inclusionPrct: Math.round((args.step_num / args.step_total) * 100)
        });
    };

    checkMiddlewareState = () => {
        const { middlewareState } = this.props;

        this.setState({
            step: 'loadingMiddleware',
            loading: true,
            error: null
        });
        let checkMiddleWareCount = 0;
        let checkMiddleware = setInterval(() => {
            const { middlewareState } = this.props;

            checkMiddleWareCount += 1;
            if (middlewareState === 'connected') {
                clearInterval(checkMiddleware);
                this.getHeatAndCoolWifiList();
            }
            if (checkMiddleWareCount > this.maxCheckMiddleware) {
                this.setState({
                    error: Translator.translate(`generic.products.addProduct.error.middlewareConnectionFail`)
                });
                clearInterval(checkMiddleware);
            }
        }, this.delayToCheckMiddleWare);
    };

    inclusionStart = () => {
        const { wifiForm } = this.state;
        const { fheCenterMac, startHeatAndCoolInclusion, middleware } = this.props;
        this.setState({
            loadingInclusion: true,
            inclusionError: null,
            currentStepSlug: null
        });
        const network = {
            auth: wifiForm.encryption,
            pass: wifiForm.password,
            ssid: wifiForm.ssid
        };
        return startHeatAndCoolInclusion(middleware, fheCenterMac, network, this.stepAction)
            .then(() => {
                this.setState({
                    step: 'inclusionSuccess',
                    loadingInclusion: false
                });
            })
            .catch(error => {
                const errorString = Translator.translateWithFallback(`socket.error.${error}`, `socket.error.defaultError`);

                this.setState({
                    inclusionError: errorString,
                    loadingInclusion: false
                });
            });
    };

    getHeatAndCoolWifiList = () => {
        const { getHeatAndCoolWifiList, fheCenterMac, middleware } = this.props;
        this.setState({
            step: 'wifiList',
            loading: true,
            error: null
        });
        return getHeatAndCoolWifiList(middleware, fheCenterMac)
            .then(data => {
                this.setState({
                    productAP: data.productAP,
                    wifiList: this.formatNetworks(data.networks),
                    loading: false
                });
            })
            .catch(error => {
                this.setState({
                    error: Translator.translateWithFallback(`socket.error.${error}`, `socket.error.failedGetWifiList`),
                    loading: false
                });
            });
    };
    renderWifiList = () => {
        const { wifiList, error } = this.state;
        const { classes, theme } = this.props;

        let wifiListArray = [];

        if (wifiList.length > 0) {
            wifiList.sort(function(a, b) {
                return b.signalLevel - a.signalLevel;
            });
            let groupedWifiList = this.getBetterSignalLevelWifi(wifiList, 'ssid');
            groupedWifiList.forEach(wifi => {
                wifiListArray.push(
                    <div key={wifi.bssid} onClick={this.selectWifi.bind(this, wifi)} role="presentation">
                        <OneWifiItem wifi={wifi} />
                        <Divider />
                    </div>
                );
            });

            return wifiListArray;
        } else {
            return (
                <div className={classes.errorTextContainer}>
                    <div style={{ color: theme.palette.error.main }}>
                        {error ? error : Translator.translate('generic.products.addProduct.error.noWifiFound')}
                    </div>
                </div>
            );
        }
    };

    getSelectedEncryptionType = memoizeOne(type => {
        return this.encryptionTypes.find(x => x.value === type);
    });

    getSelectedEncryption = memoizeOne(encryption => {
        return this.encryptions.find(x => x.value === encryption);
    });

    handleReactSelect = (event, options) => {
        const { wifiForm } = this.state;

        this.setState({
            wifiForm: { ...wifiForm, [options.name]: event.value }
        });
    };
    renderWifiForm = () => {
        const { theme, classes, resetProduct, goBack } = this.props;
        const {
            wifiForm,
            showPassword,
            wifiSelection,
            currentStepSlug,
            inclusionPrct,
            inclusionError,
            loading,
            loadingInclusion,
            errorWifi,
            productAP
        } = this.state;

        const renderWifiList = this.renderWifiList();
        return (
            <Fragment>
                <div className={classes.title}>
                    {Translator.translate(
                        'generic.products.addProduct.configWifi',
                        Translator.translate('general.products.productType.heat_and_cool'),
                        productAP
                    )}
                </div>
                <form>
                    <Grid container spacing={3}>
                        <Grid container item sm={12}>
                            <FHETextField
                                id="ssid"
                                value={!wifiForm.ssid || wifiForm.ssid === null ? '' : wifiForm.ssid}
                                label={Translator.translate('generic.products.addProduct.wifiForm.ssid')}
                                name="ssid"
                                onChange={this.handleChange}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Tooltip title={Translator.translate('generic.products.addProduct.selectWifi')} placement="top">
                                                <IconButton aria-label="Select Wifi" onClick={this.showWifiList}>
                                                    <WifiIcon level={100} color={theme.palette.primary.main} size={30} />
                                                </IconButton>
                                            </Tooltip>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Grid>
                        <Grid container item sm={12}>
                            <FHETextField
                                id="password"
                                type={showPassword ? 'text' : 'password'}
                                value={!wifiForm.password || wifiForm.password === null ? '' : wifiForm.password}
                                label={Translator.translate('generic.products.addProduct.wifiForm.password')}
                                name="password"
                                onChange={this.handleChange}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton aria-label="Toggle password visibility" onClick={this.handleClickShowPassword}>
                                                {showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6}>
                            <FHEReactSelect
                                name="encryption"
                                label={Translator.translate('generic.products.addProduct.wifiForm.encryption')}
                                onChange={this.handleReactSelect}
                                value={this.getSelectedEncryption(wifiForm.encryption)}
                                choices={this.encryptions}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6}>
                            <FHEReactSelect
                                name="encryption_type"
                                label={Translator.translate('generic.products.addProduct.wifiForm.encryption_type')}
                                onChange={this.handleReactSelect}
                                value={this.getSelectedEncryptionType(wifiForm.encryption_type)}
                                choices={this.encryptionTypes}
                            />
                        </Grid>
                    </Grid>
                    <Grid container justify="center" alignItems="center" spacing={3} className={classes.wifiFormContainer}>
                        <Grid container item sm={12} md={6} xl={3} justify="center" alignItems="center">
                            {inclusionError && <span style={{ color: theme.palette.error.main }}>{inclusionError}</span>}
                            {loadingInclusion && currentStepSlug !== null && (
                                <Fragment>
                                    <LinearProgress variant="determinate" value={inclusionPrct} />
                                    <div className={classes.stepContainer}>
                                        {Translator.translate(`generic.products.addProduct.steps.${currentStepSlug}`)}
                                    </div>
                                </Fragment>
                            )}

                            <FHEButton
                                disabled={loadingInclusion || wifiForm.ssid === null}
                                content={Translator.translate('generic.products.addProduct.inclusionStart')}
                                clickFunction={this.inclusionStart}
                                loading={loadingInclusion}
                            />
                            <FHEButton
                                disabled={loadingInclusion}
                                content={Translator.translate('generic.products.addProduct.changeProduct')}
                                clickFunction={resetProduct}
                            />
                            <FHEButton
                                disabled={loadingInclusion}
                                content={Translator.translate('generic.products.addProduct.goBack')}
                                clickFunction={goBack}
                            />
                        </Grid>
                    </Grid>
                    <Dialog open={wifiSelection} aria-labelledby="wifiSelectionDialog">
                        <div className={classes.titleWifiList}>{Translator.translate('generic.products.addProduct.wifiListTitle')}</div>
                        <DialogContent>
                            {errorWifi ? <span style={{ color: theme.palette.error.main }}>{errorWifi}</span> : <span>{renderWifiList}</span>}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.hideWifiList} color="primary">
                                {Translator.translate('generic.products.addProduct.close')}
                            </Button>
                            {loading ? (
                                <IconButton aria-label="LoadingWifiList">
                                    <CircularProgress size={25} />
                                </IconButton>
                            ) : (
                                <Tooltip title={Translator.translate('generic.products.addProduct.refresh')} placement="top">
                                    <IconButton aria-label="RefreshWifiList" onClick={this.getHeatAndCoolWifiList}>
                                        <Refresh />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </DialogActions>
                    </Dialog>
                </form>
            </Fragment>
        );
    };
    renderSuccessView = () => {
        const { productAP } = this.state;
        const { classes, resetProduct, goBack } = this.props;
        return (
            <div className={classes.confirmationContainer}>
                <div className={classes.confirmationText}>
                    {Translator.translate(
                        'generic.products.addProduct.inclusionSuccess',
                        Translator.translate('general.products.productType.heat_and_cool'),
                        productAP
                    )}
                </div>

                <Grid container direction="column" justify="center" alignItems="center">
                    <Grid container item sm={12} md={6} xl={3}>
                        <FHEButton
                            content={Translator.translate(
                                'generic.products.addProduct.addAnotherProductByType',
                                Translator.translate('general.products.productType.heat_and_cool')
                            )}
                            clickFunction={this.addAnotherProduct}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} xl={3}>
                        <FHEButton content={Translator.translate('generic.products.addProduct.addAnotherProduct')} clickFunction={resetProduct} />
                    </Grid>
                    <Grid container item sm={12} md={6} xl={3}>
                        <FHEButton content={Translator.translate('generic.products.addProduct.goBack')} clickFunction={goBack} />
                    </Grid>
                </Grid>
            </div>
        );
    };
    renderLoader = () => {
        const { classes } = this.props;
        const { step, productAP } = this.state;
        let loadingMessage = '';
        if (step === 'loadingMiddleware') {
            loadingMessage = Translator.translate(`generic.products.addProduct.loadingMiddleware`);
        } else if (step === 'wifiList') {
            loadingMessage = Translator.translate(`generic.products.addProduct.loadingWifiList`, productAP);
        }
        return (
            <Fragment>
                <div className={classes.loadingTextContainer}>{loadingMessage}</div>
                <div className={classes.loadingContainer}>
                    <CircularProgress />
                </div>
            </Fragment>
        );
    };
    renderError = () => {
        const { classes, theme, goBack } = this.props;
        const { error, step } = this.state;
        return (
            <div className={classes.retryContainer}>
                <div className={classes.errorTextContainer}>
                    <div style={{ color: theme.palette.error.main }}>{error}</div>
                </div>
                <Fragment>
                    {step === 'loadingMiddleware' ||
                        (step === 'wifiList' && (
                            <div style={{ textAlign: 'center' }}>
                                <FHEButton
                                    content={Translator.translate('generic.products.addProduct.retry')}
                                    clickFunction={this.checkMiddlewareState}
                                />
                            </div>
                        ))}
                    <div style={{ textAlign: 'center' }}>
                        <FHEButton content={Translator.translate('generic.products.addProduct.goBack')} clickFunction={goBack} />
                    </div>
                </Fragment>
            </div>
        );
    };

    render() {
        const { loading, step, error, wifiSelection } = this.state;
        const { goBack } = this.props;

        if (error) {
            return <Fragment>{this.renderError()}</Fragment>;
        }

        if (loading && !wifiSelection) {
            return <Fragment>{this.renderLoader()}</Fragment>;
        }

        if (step === 'wifiList') return this.renderWifiForm();
        if (step === 'inclusionSuccess') return this.renderSuccessView();

        return (
            <div style={{ textAlign: 'center' }}>
                <FHEButton content={Translator.translate('generic.products.addProduct.goBack')} clickFunction={goBack} />
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    return {
        middlewareState: state.environments.fhe.middleware.getIn([props.middleware, 'state'], 'pending')
    };
}

const styles = () => ({
    retryContainer: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        justifyContent: 'center'
    },
    refreshContainer: {
        marginBottom: 15,
        marginTop: 15,
        margin: '0 auto',
        textAlign: 'center',
        width: 'auto'
    },
    errorTextContainer: {
        width: '100%',
        textAlign: 'center',
        marginBottom: '10px',
        marginTop: '10px'
    },
    loadingTextContainer: {
        width: '100%',
        textAlign: 'center',
        marginBottom: '20px'
    },
    productListContainer: {
        alignSelf: 'center',
        marginBottom: 20,
        marginTop: 20,
        margin: '0 auto',
        width: 'auto',
        boxShadow: `3px 3px 20px 0px rgba(0,0,0,0.25)`
    },
    productListContainerRefresh: {
        alignSelf: 'center',
        marginBottom: 20,
        marginTop: 20,
        margin: '0 auto',
        width: 'auto'
    },
    wifiListContainer: {
        alignSelf: 'center',
        marginBottom: 20,
        marginTop: 20,
        margin: '0 auto',
        width: 'auto',
        padding: 40,
        boxShadow: `3px 3px 20px 0px rgba(0,0,0,0.25)`
    },
    wifiFormContainer: {
        alignSelf: 'center',
        marginBottom: 5,
        marginTop: 20,
        margin: '0 auto',
        width: 'auto',
        padding: 20
    },
    inclusionButton: {
        width: 'auto',
        margin: '0 auto',
        marginTop: 40,
        marginBottom: 25
    },
    stepContainer: {
        textAlign: 'center',
        marginTop: 10,
        marginBottom: 10
    },
    confirmationContainer: {
        alignSelf: 'center',
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 15,
        margin: '0 auto',
        width: 'auto',
        padding: 20
    },
    confirmationText: {
        marginBottom: 25
    },
    title: {
        marginBottom: 15,
        margin: '0 auto',
        textAlign: 'center',
        fontSize: '1.2em'
    },
    button: {
        margin: 5
    },
    titleWifiList: {
        marginTop: 15,
        marginBottom: 15,
        fontSize: '1.2em',
        marginLeft: 15
    },
    infoUpdate: {
        marginTop: 15,
        textAlign: 'center',
        fontSize: '0.8em',
        width: 'auto'
    },
    smallIcon: {
        fontSize: 15,
        marginRight: 8
    },
    loadingContainer: {
        margin: '0 auto',
        textAlign: 'center',
        alignSelf: 'center'
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getHeatAndCoolWifiList, startHeatAndCoolInclusion }, dispatch)
    )(withStyles(styles, { withTheme: true })(wizardAddHeatAndCool))
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Products/components/provisionning/WizardAddHeatAndCool.js